import { BRAND_ASSETS } from "@/lib/brand-assets";
import Image from "next/image";

interface BrandMarkProps {
  size?: number;
  className?: string;
  priority?: boolean;
  alt?: string;
}

export function BrandMark({
  size = 36,
  className,
  priority = false,
  alt = "ChickyTutor",
}: BrandMarkProps) {
  return (
    <Image
      src={BRAND_ASSETS.mark.web}
      alt={alt}
      width={size}
      height={size}
      className={className}
      priority={priority}
    />
  );
}
